import React, { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LoadingProvider } from "./contexts/LoadingContext";
import LoadingAnimation from "./components/Loading/LoadingAnimation";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie"; // Importando a biblioteca para manipulação de cookies
import { addItemToCart } from "./core/cart";

// A skin é decidida no build (REACT_APP_UI): o webpack resolve a condição em
// tempo de compilação e só a skin escolhida entra no bundle.
const Skin = lazy(() =>
  process.env.REACT_APP_UI === "v2" ? import("./ui-v2") : import("./ui-v1")
);

const App = () => {
  const [tenantData, setTenantData] = useState(null); // Dados do tenant
  const [cartItems, setCartItems] = useState([]); // Estado do carrinho
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isRestaurantOpen, setIsRestaurantOpen] = useState(false); // Estado global
  const [lastOrder, setLastOrder] = useState({}); // Estado global
  const [paymentData, setPaymentData] = useState({}); // Estado global

  // 2) Quando o tenant carregar, verifica o cookie do token
  useEffect(() => {
    if (tenantData?.slug) {
      const token = Cookies.get(`token-${tenantData.slug}`);
      setIsLoggedIn(!!token);
    }
  }, [tenantData?.slug]);

  const handleLogin = (token) => {
    Cookies.set(`token-${tenantData.slug}`, token, {
      expires: 60,
      secure: window.location.protocol === 'https:',
      path: '/',
    });
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    Cookies.remove(`token-${tenantData.slug}`, { path: '/' });
    setIsLoggedIn(false);
  };

  const addToCart = (product) => {
    setCartItems((prevItems) => addItemToCart(prevItems, product));
  };

  return (
    <LoadingProvider>
      <Router>
        <ToastContainer style={{ zIndex: 999999 }} />
        {/* <LoadingAnimation /> */}
        <Suspense fallback={null}>
        <Routes>
          {/* modo cardápio digital (como já existe) */}
          <Route
            path="/:slug/*"
            element={
              <Skin
                tenantData={tenantData}
                setTenantData={setTenantData}
                addToCart={addToCart}
                cartItems={cartItems}
                setCartItems={setCartItems}
                handleLogin={handleLogin}
                handleLogout={handleLogout}
                isLoggedIn={isLoggedIn}
                isRestaurantOpen={isRestaurantOpen}
                setIsRestaurantOpen={setIsRestaurantOpen}
                lastOrder={lastOrder}
                setLastOrder={setLastOrder}
                paymentData={paymentData}
                setPaymentData={setPaymentData}
                /* sem mesa */
              />
            }
          />

          {/* modo mesa */}
          <Route
            path="/:slug/mesa/:tableNumber/*"
            element={
              <Skin
                tenantData={tenantData}
                setTenantData={setTenantData}
                addToCart={addToCart}
                cartItems={cartItems}
                setCartItems={setCartItems}
                handleLogin={handleLogin}
                handleLogout={handleLogout}
                isLoggedIn={isLoggedIn}
                isRestaurantOpen={isRestaurantOpen}
                setIsRestaurantOpen={setIsRestaurantOpen}
                lastOrder={lastOrder}
                setLastOrder={setLastOrder}
                /* agora com mesa via params em TenantRoutes */
              />
            }
          />
        </Routes>
        </Suspense>
      </Router>
    </LoadingProvider>
  );
};

export default App;
